import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fields: [],
};

export const fieldSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    addFields: (state, action) => {
      state.fields = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addFields } = fieldSlice.actions;
export const fieldsSelector = (state) => state.fields;

export default fieldSlice.reducer;
